import ar from './ar';
import en from './en';

const translationsObject = {
  ar,
  en,
};

export default translationsObject;
